/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import CheckboxInner from '@hotjar/shared-assets/images/checkbox-inner.png';
import CursorBlock from '@hotjar/shared-assets/icons/cursor-block.ico';

const Input = styled.input`
  opacity: 0;
  position: absolute;
`;

const RadioContainer = styled.div`
  position: relative;
  display: block;
  min-height: ${({ isSmall }) => (isSmall ? 20 : 22)}px;
`;

const getBeforeSize = ({ isSmall }) => (isSmall ? 16 : 22);

const Label = styled.label`
  padding: 0;
  width: 100%;
  display: inline-block;
  font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
  line-height: 1.42857143;
  color: ${tokens.color.text_default};
  cursor: pointer;
  vertical-align: middle;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  margin: 0px;
  font-size: ${({ isSmall }) => (isSmall ? 12 : 14)}px;
  padding-left: ${({ isSmall }) => (isSmall ? 23 : 30)}px;

  ${Input}:checked + &:before {
    box-shadow: inset 0 0 0 1px ${tokens.color.ui_active},
      inset 0 0 0 12px ${tokens.color.ui_active};
  }
  ${Input}:checked + &:after {
    opacity: 1;
  }

  ${Input}:disabled+& {
    color: ${tokens.color.text_disabled};
    cursor: url(${CursorBlock}), default !important;
  }
  ${Input}:disabled+&:before {
    box-shadow: inset 0 0 0 1px ${tokens.color.ui_disabled},
      inset 0 0 0 12px ${tokens.color.ui_disabled} !important;
  }

  a {
    color: ${tokens.color.link};
  }

  &:before {
    content: '';
    background: ${tokens.color.ui_background};
    transition: all 0.2s linear;
    display: inline-block;
    vertical-align: middle;
    border-radius: 11px;
    box-shadow: inset 0 0 0 1px ${tokens.color.ui_border};
    position: absolute;
    left: 0;
    top: ${({ isSmall }) => (isSmall ? 4 : 0)}px;
    width: ${getBeforeSize}px;
    height: ${getBeforeSize}px;
  }

  &:after {
    content: '';
    position: absolute;
    opacity: 0;
    transition: all 0.3s linear;
    background: ${({ isCheckbox }) =>
      isCheckbox ? `url(${CheckboxInner}) 50% no-repeat` : tokens.color.ui_background};
    border-radius: ${({ isCheckbox }) => (isCheckbox ? 'none' : '50%')};
    width: ${({ isSmall, isCheckbox }) => {
      if (isSmall) return isCheckbox ? 14 : 8;
      return isCheckbox ? 16 : 10;
    }}px;
    height: ${({ isSmall, isCheckbox }) => {
      if (isSmall) return isCheckbox ? 12 : 8;
      return isCheckbox ? 14 : 10;
    }}px;

    top: ${({ isSmall, isCheckbox }) => {
      if (isSmall) return isCheckbox ? 7 : 8;
      return isCheckbox ? 5 : 6;
    }}px;
    left: ${({ isSmall, isCheckbox }) => {
      if (isSmall) return isCheckbox ? 1 : 4;
      return isCheckbox ? 3 : 6;
    }}px;
    background-size: ${({ isSmall, isCheckbox }) => {
      if (isSmall) return isCheckbox ? 13 : 8;
      return isCheckbox ? 16 : 10;
    }}px;
  }
`;

export const Radio = ({
  id,
  disabled,
  checked,
  children,
  className = '',
  size = 'default',
  name,
  value,
  variant = 'default',
  onChange,
}) => {
  const isSmall = size === 'small';
  return (
    <RadioContainer className={className} isSmall={isSmall}>
      <Input
        disabled={disabled}
        checked={checked}
        type="radio"
        id={id}
        onChange={onChange}
        name={name}
        value={value}
        data-testid="radio"
      />
      {children && (
        <Label isCheckbox={variant === 'checkbox'} isSmall={isSmall} htmlFor={id}>
          {children}
        </Label>
      )}
    </RadioContainer>
  );
};
